import React, { FC } from "react";
import { Form, Modal } from "antd";
import { Spinner } from "../spinner";
import { MatterTemplateForm, MatterTemplateFormValues } from "./form";
import { MatterTemplateData, PracticeArea } from "../../data-types";
import { AlertMessage, AlertMessageBanner } from "../alert-message";
import { useTaxonomyLabel } from "~/context/taxonomy-context";

export type MatterTemplateModalProps = {
  show: boolean;
  loading?: boolean;
  saving?: boolean;
  alertMessage?: AlertMessage;
  practiceAreas: PracticeArea[];
  initialValue?: { title: string };
  onSave: (data: MatterTemplateData) => void;
  onCancel: () => void;
};

export const MatterTemplateModal: FC<MatterTemplateModalProps> = ({
  show,
  loading,
  saving,
  alertMessage,
  practiceAreas,
  initialValue,
  onSave,
  onCancel,
}) => {
  const [form] = Form.useForm<MatterTemplateFormValues>();

  const isCloning = initialValue !== undefined && initialValue !== null;
  const taxonomy = useTaxonomyLabel();

  return (
    <Modal
      open={show}
      width="850px"
      closable={false}
      okText={
        isCloning ? `Clone Matter ${taxonomy.Template}` : `Create Matter ${taxonomy.Template}`
      }
      okButtonProps={{
        type: "primary",
        onClick: () => form.submit(),
        loading: saving,
        disabled: saving || loading,
      }}
      cancelText="Cancel"
      cancelButtonProps={{
        onClick: onCancel,
        disabled: saving,
      }}
    >
      <Spinner
        show={loading === true || saving === true}
        message={
          saving
            ? isCloning
              ? "Cloning matter template..."
              : "Creating matter template..."
            : undefined
        }
      >
        {alertMessage && <AlertMessageBanner {...alertMessage} />}
        <MatterTemplateForm
          form={form}
          practiceAreas={practiceAreas}
          initialValue={initialValue}
          onSave={onSave}
        />
      </Spinner>
    </Modal>
  );
};
